exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header {\n  border-bottom: none !important;\n}\n.profile_img {\n  width: 54px;\n}\n.m-t-60 {\n  margin-top: 60px;\n}", ""]);

// exports
